import { cn } from '@/lib/utils'

interface ScoreBadgeProps {
  label: string
  score: number
  className?: string
}

export function ScoreBadge({ label, score, className }: ScoreBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full bg-muted px-2 py-0.5 text-xs font-medium text-muted-foreground',
        className
      )}
    >
      {label}
      <span className="font-mono">{score.toFixed(3)}</span>
    </span>
  )
}
